<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Pedidos"
        :help="true"
        titleHelp="Ajuda - Pedidos"
        content="Tela responsável por pesquisar todos os tipos de pedidos, possibilitando pesquisa com filtros.">
      </page-title>
      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 col-xl-4">
            <anosafra-multiselect
              v-model="filter.anoSafra"
              label="Ano Safra"
            />
          </div>

          <div class="col-12 col-md-4 col-xl-4">
            <label class="form-control-label mb-2 mt-3">Empresa</label>
            <multiselect
              v-model="filter.enterprises"
              :options="enterprises"
              label="iden_emp"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="FABRICANTE"
              track-by="codi_emp"
              @search-change="getEnterprises"
            />
          </div>

          <div class="col-12 col-md-4 col-xl-4">
            <label class="form-control-label mb-2 mt-3">Gerente Comercial</label>
            <multiselect
              v-model="filter.manager"
              :options="managers"
              :loading="isLoadingManager"
              placeholder="Selecionar Gerente Comercial"
              :selected-label="'Selecionado'"
              label="name"
              track-by="id"
            />
          </div>

          <div class="col-12 col-md-4 col-xl-4">
            <label class="form-control-label mb-2 mt-3">Vendedor</label>
            <multiselect
              v-model="filter.salesman"
              :options="salesmen"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :loading="isLoadingSalesman"
              placeholder="Selecione vendedor"
              label="name"
              track-by="id"
            />
          </div>

          <div class="col-12 col-md-4 col-xl-4 pt-3">
            <client-filter-select  :selected="filter.client" />
          </div>

          <div class="col-12 col-md-4 col-xl-4">
            <label class="form-control-label mb-2 mt-3">Código do pedido</label>
            <multiselect
              v-model="filter.orderCode"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :options="purchase_orders"
              :loading="!purchase_orders.length"
              track-by="id"
              label="id"
              placeholder="Selecione o código"
              :show-no-options="false"
            />
          </div>

          <div class="col-12 col-md-4 col-xl-4">
            <label class="form-control-label d-block mb-2 mt-3"
              >A partir de</label
            >
            <el-date-picker
              v-model="filter.startDate"
              type="date"
              placeholder="Data início"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              rules="required"
              :editable="true"
            />
          </div>
          <div class="col-12 col-md-4 col-xl-4">
            <label class="form-control-label d-block mb-2 mt-3">Até</label>
            <el-date-picker
              v-model="filter.endDate"
              type="date"
              placeholder="Data Fim"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              rules="required"
              :editable="true"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
            <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
            <base-button type="secondary" class="mr-2" @click="generatePDF">Gerar PDF</base-button>
            <base-button type="secondary" class="mr-2" @click="exportToExcel()">Gerar Excel</base-button>
            <base-button type="primary" class="mr-2" @click="generateReport" v-loading="isLoading"
              >Relatório Geral</base-button>
              <base-button type="info" @click="generateReport(1, true)" v-loading="isLoading"
              >Relatório analítico</base-button>
        </div>
      </card>
    </div>


      <!-- Consulta -->
      <card v-if="purchase_orders.length && analycticalReport === false" v-loading="isLoading" ref="report">
        <div class="col hide-on-print">
          <h5 class="h3 mb-0">Relatório</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Pedidos
          </h6>
          <h6
            v-if="filter.salesman && Object.keys(filter.salesman).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Vendedor - {{ filter.salesman.name }}
          </h6>
          <h6
            v-if="filter.salesman && Object.keys(filter.salesman).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Cliente - {{ filter.client.name }}
          </h6>
          <h6
            v-if="filter.anoSafra && Object.keys(filter.anoSafra).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Ano Safra - {{ filter.anoSafra.descricao }}
          </h6>
          <h6
            v-if="filter.manager && Object.keys(filter.manager).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Gerente Comercial - {{ filter.manager.name }}
          </h6>
          <h6
            v-if="filter.enterprise && Object.keys(filter.enterprise).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Empresa - {{ filter.enterprise.iden_emp }}
          </h6>
          <h6
            v-if="filter.startDate && Object.keys(filter.startDate).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Data Início - {{ filter.startDate | formatDate("full") }}
          </h6>
          <h6
            v-if="filter.endDate && Object.keys(filter.endDate).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Data Fim - {{ filter.endDate | formatDate("full") }}
          </h6>
        </div>

        <card>
          <el-table
            :data="purchase_orders"
            id="generalTable"
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
            :summary-method="getSummaries"
            show-summary
          >

            <!-- Id -->
            <el-table-column
              :formatter="numberFormatter"
              label="Identificação"
              prop="id"
              min-width="125px"
              sortable
            />

            <!-- Salesman -->
            <el-table-column
              label="Nome do vendedor"
              prop="user.name"
              min-width="125px"
              sortable
            />

            <!-- Client Name -->
            <el-table-column
              label="Nome do Cliente"
              prop="client.name"
              min-width="125px"
              sortable
            />

            <!-- Total cost -->
            <el-table-column
              :formatter="costFormatter"
              label="Custo total"
              prop="total_cost"
              min-width="125px"
              sortable
            />

            <!-- Order Status | Orçamento | Pedido  -->
            <el-table-column
              :formatter="formatStatusOrder"
              label="Status"
              min-width="125px"
              prop="status_order"
              sortable
            />
          </el-table>
          <br />
          <br />
        </card>
      </card>

      <card v-if="purchase_orders.length && analycticalReport === true" v-loading="isLoading" ref="report">
        <div class="col hide-on-print">
          <h5 class="h3 mb-0">Relatório analítico</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Pedidos
          </h6>
          <h6
            v-if="filter.salesman && Object.keys(filter.salesman).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Vendedor - {{ filter.salesman.name }}
          </h6>
          <h6
            v-if="filter.salesman && Object.keys(filter.salesman).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Cliente - {{ filter.client.name }}
          </h6>
          <h6
            v-if="filter.anoSafra && Object.keys(filter.anoSafra).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Ano Safra - {{ filter.anoSafra.descricao }}
          </h6>
          <h6
            v-if="filter.manager && Object.keys(filter.manager).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Gerente Comercial - {{ filter.manager.name }}
          </h6>
          <h6
            v-if="filter.enterprise && Object.keys(filter.enterprise).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Empresa - {{ filter.enterprise.iden_emp }}
          </h6>
          <h6
            v-if="filter.startDate && Object.keys(filter.startDate).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Data Início - {{ filter.startDate | formatDate("full") }}
          </h6>
          <h6
            v-if="filter.endDate && Object.keys(filter.endDate).length"
            class="text-uppercase text-muted ls-1 mb-1"
          >
            Data Fim - {{ filter.endDate | formatDate("full") }}
          </h6>
        </div>

        <card>
          <el-table
            :data="purchase_orders"
            id="analyticalTable"
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
            :summary-method="getSummaries"
            show-summary
          >

            <!-- Id -->
            <el-table-column
              :formatter="numberFormatter"
              label="Identificação"
              prop="id"
              min-width="125px"
              sortable
            />

            <!-- Salesman -->
            <el-table-column
              label="Nome do vendedor"
              prop="user.name"
              min-width="125px"
              sortable
            />

            <!-- Client Name -->
            <el-table-column
              label="Nome do Cliente"
              prop="client.name"
              min-width="125px"
              sortable
            />

            <!-- Total cost -->
            <el-table-column
              :formatter="costFormatter"
              label="Custo total"
              prop="total_cost"
              min-width="125px"
              sortable
            />

            <!-- Created_at  -->
            <el-table-column
              :formatter="formatCreatedAt"
              label="Data de registro"
              min-width="125px"
              prop="created_at"
              sortable
            />

            <!-- Order Status | Orçamento | Pedido  -->
            <el-table-column
              :formatter="formatStatusOrder"
              label="Status"
              min-width="125px"
              prop="status_order"
              sortable
            />

            <!--Order rejection justificative -->
            <el-table-column
              :formatter="formatJustificationBudget"
              label="Justificativa"
              min-width="125px"
              prop="justification_budget_rejection"
              sortable
            />
          </el-table>
          <br />
          <br />
        </card>
      </card>
    <div slot="footer" class="py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data['current']"
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      ></base-pagination>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import ClientFilterSelect from "../../components/Widgets/Clients/ClientFilterSelect.vue";
import { Table, TableColumn, DatePicker } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    ClientFilterSelect,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      filter: {
        salesman:{},
        client:{},
        anoSafra: {},
        manager: {},
        enterprise: {},
        orderCode: null,
        startDate: "",
        endDate: "",
      },
      managers: [],
      anoSafras: [],
      salesmen: [],
      enterprises: [],
      isLoadingManager: false,
      isLoadingSalesman: false,
      currentUser: {},
      users: [],
      purchase_orders: [],
      paginated_data: [],
      lastEdition: new Date(),
      isLoading: false,
      analycticalReport: false,
    };
  },
  methods: {
    async generateReport(page = 1, analytical = false) {
      this.analycticalReport = analytical

      if (this.filter.startDate > this.filter.endDate) {
        this.$toasted.global.defaultWarnig({msg: "Data de início não pode ser maior que a data final"});
      return;
      }

      this.isLoading = true
      try {
      const response = await this.$http.secured
        .get("/api/v1/report/purchase_orders", {
          params: {
            service_params: {
              id: this.filter.orderCode ? this.filter.orderCode.id : null,
              salesman_id: this.filter.salesman
                ? this.filter.salesman.id
                : null,
              client_id: this.filter.client
                ? this.filter.client.value
                : null,
              anosafra_id: this.filter.anoSafra
                ? this.filter.anoSafra.value
                : null,
              manager_id: this.filter.manager
                ? this.filter.manager.id
                : null,
              codi_emp: this.filter.enterprise
                ? this.filter.enterprise.value
                : null,
              start_date: this.filter.startDate
                ? this.filter.startDate
                : null,
              end_date: this.filter.endDate
                ? this.filter.endDate
                : null,
              page: page
            }
          },
        })

        if(response) {
          this.purchase_orders = response.data.data;
        }
        this.isLoading = false;
      }
      catch(error) {
        console.log(error)

      }
    },
    clearFilters() {
      this.filter.enterprises = {},
      this.filter.manager = {},
      this.filter.salesman = {},
      this.filter.orderCode = null,
      this.filter.client = {},
      this.filter.startDate = "",
      this.filter.endDate = ""
    },
    getEnterprises(q = "") {
      this.$http.secured
        .get("/api/v1/report/enterprise_data", {
          params: { q: { iden_emp: q, situ_emp: "A" } },
        })
        .then((response) => {
          this.enterprises = response.data;
          console.log(response.data);
          this.enterprises.shift();
          this.enterprises.shift();

        })
        .catch((error) =>
          this.setError(
            error,
            this.$toasted.global.defaultWarnig({
              msg: "Fabricantes não encontrados",
            })
          )
        );
    },
    initManagers(query) {
      this.isLoadingManager = true;
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };

      if(this.filter.anoSafra && this.filter.anoSafra.id)
        data.q['anosafra_id'] = this.filter.anoSafra.id

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.managers = response.data.users || [];
          this.isLoadingManager = false;
        })
        .catch(() => {
          this.isLoadingManager = true;
        });
    },
    initSalesmen(query) {
      this.isLoadingSalesman = true;
      var data = {
        name_only: true,
        q: { name: query, is_salesman: true, status: this.active }
      }

      if (this.filter.manager && this.filter.manager.id)
        data.q["manager_id"] = this.filter.manager.id;
      if (this.filter.manager && this.filter.manager.coordinated_id)
        data.q["manager_id"] = this.filter.manager.coordinated_id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/users", {params:data})
        .then((response) => {
          this.isLoadingSalesman = false;
          this.salesmen = response.data || []
        })
        .catch(() => (this.isLoadingSalesman = false))
    },
    findManagers(query) {
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };

      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.filter.isLoadingManagers = false;
          this.filter.managers = response.data.users || [];
        })
        .catch(() => (this.filter.isLoadingManagers = false));
    },
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    numberFormatter(_row, _column, value) {
      return parseFloat(value || 0).toLocaleString("pt-BR", { day: "numeric" });
    },
    costFormatter(_row, _column, value) {
      return parseFloat(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "brl",
      });
    },
    getUsers() {
      let data = { q: {}  };

       if (this.filter.role && this.filter.role.id) {
        data.q.role_id = this.filter.role.id;
      }
       if (this.filter.channel && this.filter.channel.id) {
        data.q.channel_id = this.filter.channel.id;
      }
      if (this.filter.type) {
        data.q.salesman_type = this.filter.type.code;
      }
      if (this.filter.manager && this.filter.manager.id) {
        data.q.manager_id = this.filter.manager.id;
      }

      console.log(data);
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.users = response.data.users;
        });
    },
    getSummaries(param) {
      if (!Object.keys(param).length) return;

      var { columns, data } = param;
      var sums = [];

      for (const index in columns) {
        if (index == 0) {
          sums[index] = "TOTAL";
          continue;
        }
        if (index == 1) {
          sums[index] = "";
          continue;
        }
        if (index == 4) {
          sums[index] = "";
          continue;
        }

        var values = data.map((item) => Number(item[columns[index].property]));

        sums[index] = values.reduce(
          (prev, curr) => (Number(curr) || 0) + prev,
          0
        );
      }

      // Aqui é que está bugando
      sums[2] = null
      sums[3] = parseFloat(sums[3]).toLocaleString("pt-BR", {
        style: "currency",
        currency: "brl",
      });
      sums[5] = null
      sums[6] = null
      return sums;
    },
    formatStatusOrder(_row, _column, value){
      console.log(value)
      switch (value) {
        case 'deferred':
          return 'Pedido'
        case 'pending':
          return 'Orçamento'
        case 'rejected':
          return 'Orçamento recusado'
        default:
          return 'Não identificado'
      }
    },
    changePage(page) {
      this.generateReport(page);
    },
    formatCreatedAt(_row, _column, value) {
      return this.$options.filters.formatDate(value, "short");
    },
    formatJustificationBudget(_row, _column, value) {
      if(value) {
        return value > 100 ? value.substring(0, 100) + '...' : value
      } else {
        return 'Não informado'
      }
    }
  },
  mounted() {
    this.getUsers();
    this.getEnterprises();
    this.initSalesmen("");
    this.initManagers("");
  },
  watch: {
    "filter.anoSafra": function () {
      if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
      this.initManagers("");
    },
    "filter.orderCode": function () {
      this.generateReport()
    },
    "filter.manager": function () {
      this.generateReport()
    },

  }
};
</script>

<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
</style>
